import { Component } from '@angular/core';
import { Sidebar } from '../../core/services/sidebar';

@Component({
  selector: 'app-cards',
  imports: [],
  templateUrl: './cards.html',
  styleUrl: './cards.css'
})
export class Cards {
  constructor(
    private sidebarService: Sidebar,
  ) { }

  ngOnInit() {
    this.sidebarService.setToDefault();
  }
}
